import { useQuery } from '@tanstack/react-query';
import API from '../../../../context/API';
import { useActiveStoreId } from '../../../Stores/hooks';
import { requireActiveStoreId } from '../../../../utils/activeStore';
import { CustomizationSoldOutItem } from '../types';
import { QUERY_KEYS, FETCH_LIMIT } from '../constants';

function sortByUpdatedAt(data: CustomizationSoldOutItem[]): CustomizationSoldOutItem[] {
  return [...data].sort(
    (a, b) => new Date(b.updatedAt || 0).getTime() - new Date(a.updatedAt || 0).getTime()
  );
}

async function fetchSoldOutCustomizations(search: string): Promise<CustomizationSoldOutItem[]> {
  const storeId = requireActiveStoreId();
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const response = await API.get(
    `/customizations?page=1&limit=${FETCH_LIMIT}${searchParam}&storeId=${storeId}`
  );
  const soldOutItems = response.data.data.filter(
    (customization: CustomizationSoldOutItem) => Boolean(customization.sold_out) === true
  );
  return sortByUpdatedAt(soldOutItems);
}

export function useCustomizationSoldOutQuery(search: string, enabled = true) {
  const storeId = useActiveStoreId();

  return useQuery({
    queryKey: [QUERY_KEYS.SOLD_OUT_CUSTOMIZATIONS, search, storeId],
    queryFn: () => fetchSoldOutCustomizations(search),
    staleTime: 0,
    placeholderData: (prevData, prevQuery) =>
      prevQuery?.queryKey[2] === storeId ? prevData : undefined,
    enabled: enabled && !!storeId,
  });
}
